import Sidebar from "~/components/Sidebar";
import AdminNavbar from "~/components/Navbars/admin-navbar";

function Footer() {
  return (
    <footer className="block py-4 bg-gray-400">
      <div className="container mx-auto px-4">
        <hr className="mb-4 border-b-1 border-blueGray-200" />
        <div className="flex flex-wrap items-center md:justify-between justify-center">
          <div className="w-full md:w-4/12 px-4">
            <div className="text-sm text-blueGray-500 font-semibold py-1 text-center md:text-left">
              Copyright © {new Date().getFullYear()}{" "}
              <a
                href="https://www.creative-tim.com?ref=nnjs-footer-admin"
                className="text-blueGray-500 hover:text-blueGray-700 text-sm font-semibold py-1"
              >
                Creative Tim
              </a>
            </div>
          </div>
          <div className="w-full md:w-8/12 px-4">
            <ul className="flex flex-wrap list-none md:justify-end  justify-center">
              <li>
                <a
                  href="https://www.creative-tim.com?ref=nnjs-footer-admin"
                  className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                >
                  Creative Tim
                </a>
              </li>
              <li>
                <a
                  href="https://www.creative-tim.com/presentation?ref=nnjs-footer-admin"
                  className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="http://blog.creative-tim.com?ref=nnjs-footer-admin"
                  className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                >
                  Blog
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/creativetimofficial/notus-nextjs/blob/main/LICENSE.md?ref=nnjs-footer-admin"
                  className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                >
                  MIT License
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default function AdminLayout({ children }) {
  return (
    <>
      <Sidebar />
      <div className="font-sans relative md:ml-64 ">
        <AdminNavbar />
        <div
          // style={{ height: "calc(100vh - 200px)" }}
          className="px-4 md:px-10 mx-auto overflow-auto md:h-screen w-full pt-12 md:pt-24 bg-gray-50"
        >
          {children}
          {/* <Footer /> */}
        </div>
        {/* <Footer /> */}
        {/* <div>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quis sed
          nesciunt similique eum ex cupiditate tempore ut excepturi et quaerat
          nostrum dolorum, officia repellat expedita numquam vero quos
          recusandae. Cum.
        </div> */}
        {/* <div className="relative md:ml-64 pb-32 bg-gray-400">{children}</div> */}
      </div>
    </>
  );
}
